import actions from './actions';

const MIN_DATE = '1900-01-01';
const MAX_DATE = '9999-12-31';

const initState = {
    dateRange: {}
};

export default function GlobalReducer(state = initState, action) {
    switch (action.type) {
        case actions.Date_Range:
            return {
                ...state,
                dateRange: safeDateRange(action.payload.data)
            };
        default:
            return state;
    }
}


function safeDateRange(dateRange) {
    const range = dateRange || {};
    const normalize = (value, fallback) => (value === 'None' || value === undefined || value === null ? fallback : value);

    return {
        date_range_elec_min: normalize(range.date_range_elec_min, MAX_DATE),
        date_range_elec_max: normalize(range.date_range_elec_max, MIN_DATE),
        date_range_gas_min: normalize(range.date_range_gas_min, MAX_DATE),
        date_range_gas_max: normalize(range.date_range_gas_max, MIN_DATE),
    };
}
